import { useEffect, useState } from "react";
import { useNotificationContext } from "cerulean";
import { Dialog, Row, Button, Radio } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";

type PostingDialogType = {
  isOpen: boolean;
  handleClose: () => void;
  form: {
    values: { groupPosting: boolean };
    setFieldValue: (field: string, value: unknown) => void;
  };
};

const PostingDialog = ({ isOpen, handleClose, form }: PostingDialogType) => {
  const { l10n } = useLocalization();
  const { sendNotification } = useNotificationContext();
  const { values } = form;
  const { groupPosting } = values;
  const [groupPostingOn, setGroupPostingOn] = useState<boolean>(groupPosting);

  const handleToggleRadioButton = (value: string) => {
    const updatedValue = value === "true";
    setGroupPostingOn(updatedValue);
  };

  const handleSave = () => {
    form.setFieldValue("groupPosting", groupPostingOn);
    sendNotification({
      type: "success",
      text: l10n.getString("success-changes-saved"),
    });
    handleClose();
  };

  useEffect(() => {
    setGroupPostingOn(groupPosting);
  }, [isOpen]);

  return (
    <Dialog
      isOpen={isOpen}
      onUserDismiss={handleClose}
      title={l10n.getString("posting-dialog-heading")}
      footer={
        <Row alignItems="center" justifyContent="end">
          <Row.Item shrink>
            <Button
              onClick={handleClose}
              kind="negative"
              label={l10n.getString("button-cancel")}
              testId="posting-dialog-cancel-button"
            />
          </Row.Item>
          <Row.Item shrink>
            <Button
              onClick={handleSave}
              kind="primary"
              label={l10n.getString("button-save-changes")}
              testId="posting-dialog-save-button"
            />
          </Row.Item>
        </Row>
      }
    >
      <div className="margin--top--s">
        <span>{l10n.getString("posting-dialog-content")}</span>
      </div>
      <div className="margin--top--l">
        <Radio
          name=""
          checked={!groupPostingOn}
          value="false"
          onCheck={handleToggleRadioButton}
        >
          <strong>{l10n.getString("posting-dialog-option-single")}</strong>:{" "}
          {l10n.getString("posting-dialog-option-single-content")}
        </Radio>
      </div>
      <div className="margin--top--m">
        <Radio
          name=""
          checked={groupPostingOn}
          value="true"
          onCheck={handleToggleRadioButton}
        >
          <strong>{l10n.getString("posting-dialog-option-combined")}</strong>:{" "}
          {l10n.getString("posting-dialog-option-combined-content")}
        </Radio>
      </div>
    </Dialog>
  );
};

export default PostingDialog;
